import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {first} from 'lodash'
import cn from 'classnames'
import {DetailedPaymentError} from '@raisenow/epik'
import {useStores} from '../../lib/MobXProvider'
import {WidgetApi} from '../../lib/WidgetApi'
import {ValidationErrors} from '../../lib/Validator'

///////////////////////////////////////////////////////////////////////////////

export type ErrorMessageProps = {
  errors: ValidationErrors
  errorKey: string
  stubErrorCode?: string
  id?: string
}

///////////////////////////////////////////////////////////////////////////////

export const ErrorMessage: FC<ErrorMessageProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {errors, errorKey, stubErrorCode, id} = props

  let error: DetailedPaymentError =
    errors && errors[errorKey] && first(errors[errorKey])

  if (stubErrorCode) {
    error = {code: stubErrorCode, message: stubErrorCode}
  }

  const errorMessage =
    (error && error.message) ||
    (api.computedConfig.debugErrorMessages &&
      'Sample error message "' + errorKey + '"')

  return (
    <div
      className={cn('error-message', {'has-error': !!errorMessage})}
      aria-live="assertive"
      aria-relevant="all"
      id={id}
    >
      {errorMessage}
    </div>
  )
})
